<template>
  <div>
    <loading
      :active="isLoading"
      loader="bars"
      color="#7367f0"
      :is-full-page="fullPage"
    />
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-3"
      @on-complete="formSubmitted"
    >
      <!-- Scheduling -->
      <tab-content
        title="Schedule"
        icon="feather icon-calendar"
        :before-change="validationFormSchedule"
      >
        <validation-observer
          ref="schedule"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Schedule
              </h5>
              <small class="text-muted">
                Enter the GMS church name, open date, close date and maximum approval date.
              </small>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Church"
                rules="required"
              >
                <b-form-group
                  label="GMS"
                  label-for="churches"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="churches"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="churchOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                vid="openDate"
                name="Open Date"
                rules="required|open_date_validation:@closeDate,@maximumApprovalDate"
              >
                <b-form-group
                  label="Open date"
                  label-for="open_date"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-datepicker
                    v-model="open_date"
                    class="mb-1"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                vid="closeDate"
                name="Close date"
                rules="required|close_date_validation:@openDate,@maximumApprovalDate"
              >
                <b-form-group
                  label="Close Date"
                  label-for="close_date"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-datepicker
                    v-model="close_date"
                    class="mb-1"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                vid="maximumApprovalDate"
                name="Maximum approval date"
                rules="required|approval_date_validation:@openDate,@closeDate"
              >
                <b-form-group
                  label="Maximum Approval Date"
                  label-for="maximum_approval_date"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-datepicker
                    v-model="maximum_approval_date"
                    class="mb-1"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Requirements -->
      <tab-content
        title="Requirements"
        icon="feather icon-shield"
        :before-change="validationFormRequirements"
      >
        <validation-observer
          ref="requirements"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Requirement Details
              </h5>
              <small class="text-muted">Customize your requirements.</small>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="NIJ Requirement"
                rules="required"
              >
                <b-form-group
                  label="NIJ Required ?"
                  label-for="nij_required"
                  :state="errors.length > 0 ? false:null"
                >
                  <div
                    class="demo-inline-spacing"
                    style="margin-top: -15px;"
                  >
                    <b-form-radio
                      v-model="nij_required"
                      value="yes"
                      class="custom-control-primary"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="nij_required"
                      value="no"
                      class="custom-control-secondary"
                    >
                      No
                    </b-form-radio>
                  </div>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Baptism Requirement"
                rules="required"
              >
                <b-form-group
                  label="Baptism Required ?"
                  label-for="baptism_required"
                  :state="errors.length > 0 ? false:null"
                >
                  <div
                    class="demo-inline-spacing"
                    style="margin-top: -15px;"
                  >
                    <b-form-radio
                      v-model="baptism_required"
                      value="yes"
                      class="custom-control-primary"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="baptism_required"
                      value="no"
                      class="custom-control-secondary"
                    >
                      No
                    </b-form-radio>
                  </div>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Assessment Broadcasted Requirement"
                rules="required"
              >
                <b-form-group
                  label="Is Assessment Broadcasted ?"
                  label-for="isAssessmentBroadcasted"
                  :state="errors.length > 0 ? false:null"
                >
                  <div
                    class="demo-inline-spacing"
                    style="margin-top: -15px;"
                  >
                    <b-form-radio
                      v-model="isAssessmentBroadcasted"
                      value="yes"
                      class="custom-control-primary"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="isAssessmentBroadcasted"
                      value="no"
                      class="custom-control-secondary"
                    >
                      No
                    </b-form-radio>
                  </div>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="MSJ Requirement"
                rules="required"
              >
                <b-form-group
                  label="MSJ Requirement"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="msjSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="msjOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Terms & Conditions"
              >
                <quill-editor
                  v-model="termsConditions"
                  :options="snowOption"
                  @change="onEditorChange($event)"
                  @ready="onEditorReady($event)"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Ministry Types -->
      <tab-content
        title="Ministry Types"
        icon="feather icon-type"
        :before-change="validationFormMinistryTypes"
      >
        <validation-observer
          ref="ministryTypes"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ministry Type
              </h5>
              <small class="text-muted">Determine the ministry and division type.</small>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="Servolution Type"
                rules="required"
              >
                <b-form-group
                  label="Servolution Type"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="servolutionType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="servolutionTypeOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="servolutionType.id === 1">
            <b-col
              cols="12"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="Type of First and Second Option"
                rules="required"
              >
                <b-form-group
                  label="Choose the type of first and second option"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="firstSecondMinistryType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="firstSecondMinistryTypeOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <!-- Audition Type -->
            <b-col md="6">
              <h6 class="text-primary font-weight-bold mb-2">
                Audition & Interview
              </h6>

              <!-- draggable -->
              <draggable
                :list="auditions"
                tag="ul"
                group="people"
                class="list-group list-group-flush cursor-move"
              >
                <b-list-group-item
                  v-for="(listItem, index) in auditions"
                  :key="index"
                  tag="li"
                >
                  <div class="d-flex">
                    <div class="ml-25">
                      <b-card-text class="mb-0 font-weight-bold">
                        {{ listItem.ministry }}
                      </b-card-text>
                      <small>{{ listItem.division }}</small>
                    </div>
                  </div>
                </b-list-group-item>
              </draggable>
            </b-col>

            <!-- Interview Type -->
            <b-col
              md="6"
              class="mt-sm-2 mt-md-0"
            >
              <h6 class="text-primary font-weight-bold mb-2">
                Interview Only
              </h6>

              <!-- draggable -->
              <draggable
                :list="interviews"
                tag="ul"
                group="people"
                class="list-group list-group-flush cursor-move"
              >
                <b-list-group-item
                  v-for="(listItem, index) in interviews"
                  :key="index"
                  tag="li"
                >
                  <div class="d-flex">
                    <div class="ml-25">
                      <b-card-text class="mb-0 font-weight-bold">
                        {{ listItem.ministry }}
                      </b-card-text>
                      <small>{{ listItem.division }}</small>
                    </div>
                  </div>
                </b-list-group-item>
              </draggable>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Ministry Options -->
      <tab-content
        title="Ministry Options"
        icon="feather icon-check-circle"
        :before-change="validationFormMinistryOptions"
      >
        <validation-observer
          ref="ministryOptions"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ministry Options
              </h5>
              <small class="text-muted">Set the ministry options that the users will choose.</small>
            </b-col>
            <b-col
              v-if="servolutionType.id === 1"
              md="12"
            >
              <validation-provider
                #default="{ errors }"
                name="First Options"
                rules="required"
              >
                <b-form-group
                  label="First Options"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="firstOptionLists"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="firstOptionListsOptions"
                    @option:selected="firstOptionSelected"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="servolutionType.id === 1"
              md="12"
            >
              <validation-provider
                #default="{ errors }"
                name="Second Options"
                rules="required"
              >
                <b-form-group
                  label="Second Options"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="secondOptionLists"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="secondOptionListsOptions"
                    @option:selected="secondOptionSelected"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="servolutionType.id === 2"
              md="12"
            >
              <validation-provider
                #default="{ errors }"
                name="Options"
                rules="required"
              >
                <b-form-group
                  label="Options"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="servolutionOptionLists"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="servolutionOptionListsOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import _ from 'lodash'
import vSelect from 'vue-select'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loading from 'vue-loading-overlay'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import {
  BRow,
  BCol,
  BFormGroup,
  // BFormInput,
  BFormDatepicker,
  BFormRadio,
  BListGroupItem,
  BCardText,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import Ripple from 'vue-ripple-directive'
// import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import * as moment from 'moment'
import { quillEditor } from 'vue-quill-editor'
import { required, email } from '@validations'
import { isUserLoggedIn } from '@/auth/utils'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    Loading,
    BFormDatepicker,
    BFormRadio,
    draggable,
    BListGroupItem,
    BCardText,
    quillEditor,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      churches: [],
      churchOptions: [],
      open_date: '',
      close_date: '',
      maximum_approval_date: '',
      nij_required: '',
      baptism_required: '',
      isAssessmentBroadcasted: '',
      msjSelected: { id: 2, name: 'MSJ 2' },
      msjOptions: [
        { id: 1, name: 'MSJ 1' },
        { id: 2, name: 'MSJ 2' },
      ],
      snowOption: {
        theme: 'snow',
      },
      termsConditions: '<h3><span style="font-weight: bolder;">Syarat</span></h3><ol style="font-size: 14px;"><li>Telah lulus MSJ (My Spiritual Journey) 2.</li><li>Sudah Baptis Selam.</li><li>Sudah menerima Baptisan Roh Kudus.</li><li>Aktif di dalam keanggotaan Connect Group (CG).</li><li>Rekomendasi pemimpin CG (untuk memastikan kesiapan member dalam melayani)<span class="Apple-converted-space" style="font-family: Calibri; font-size: 11.5px;"> </span>.</li></ol><h3><span style="font-weight: bolder;">Ketentuan</span></h3><ol style="font-size: 14px;"><li>Pendaftaran servolution dilakukan secara online melalui apps GMS Church lalu klik icon <span style="font-weight: bolder;"><span style="font-weight: bolder;">Servolution</span></span>.</li><li>Pendaftaran dibuka mulai <span style="font-weight: bolder;"><span style="font-weight: bolder;">{diisi}</span></span></li><li>Pastikan GMS tempat dimana anda beribadah sudah sesuai di bagian Edit Profile, GMS (city), yaitu <span style="font-weight: bolder;"><span style="font-weight: bolder;">{{diisi}}</span></span></li><li>Apabila Anda belum pernah melengkapi data baptisan, maka sebelum memilih pelayanan, Anda diwajibkan melengkapi data baptisan Anda terlebih dahulu.</li><li>Hanya diperbolehkan mengambil satu bidang pelayanan saja.</li><li>Peserta yang mendaftar pada departemen yang memerlukan audisi, wajib memilih opsi kedua pilihan departemen (sebagai bentuk antisipasi apabila tidak lolos pada audisi departemen opsi pertama).</li><li>Data Baptisan Anda akan diverifikasi terlebih dahulu sebelum lanjut ke proses persetujuan pemimpin (bagi Peserta yang belum pernah melengkapi data baptisan).<br></li><li>Jadwal serta ketentuan audisi dan interview akan diinformasikan melalui aplikasi GMS Church/Email atau melalui departemen yang bersangkutan.</li><li>Nomor Mobile Phone (HP) dan Email yang disertakan harus aktif. Jika ada informasi yang disampaikan lewat HP/Email dan Anda tidak menerimanya dikarenakan kesalahan penulisan atau nomor/email yang tidak aktif, maka segala resiko bukan tanggung jawab kami, contoh: tidak diterima di pelayanan.</li><li>Syarat kelengkapan (dilampirkan via online pada saat mendaftar) seperti <span style="font-weight: bolder;">Foto Diri.</span></li><li>Kelulusan akan diumumkan melalui Push Notification di Aplikasi GMS Church dan Email.</li></ol>',
      termsConditionsLength: 1,
      servolutionType: [],
      servolutionTypeOptions: [],
      firstSecondMinistryType: [],
      firstSecondMinistryTypeOptions: [
        { id: 0, name: 'Optional' },
        { id: 1, name: 'Mandatory' },
      ],
      required,
      email,
      auditions: [],
      interviews: [],
      columns: [
        {
          label: 'Ministry',
          field: 'ministry',
        },
        {
          label: 'Division',
          field: 'division',
        },
      ],
      rows: [],
      firstOptionLists: [],
      firstOptionListsOptions: [],
      secondOptionLists: [],
      secondOptionListsOptions: [],
      servolutionOptionLists: [],
      servolutionOptionListsOptions: [],
    }
  },
  created() {
    // Open date validation
    extend('open_date_validation', {
      params: ['close', 'approval'],
      validate(value, { close, approval }) {
        const openDate = moment(value).format('YYYY-MM-DD')
        const closeDate = moment(close).format('YYYY-MM-DD')
        const maximumApprovalDate = moment(approval).format('YYYY-MM-DD')

        return moment(openDate).isBefore(closeDate) && moment(openDate).isBefore(maximumApprovalDate)
      },
      message: 'The open date must be less than the close and maximum approval date',
    })

    // Close date validation
    extend('close_date_validation', {
      params: ['open', 'approval'],
      validate(value, { open, approval }) {
        const openDate = moment(open).format('YYYY-MM-DD')
        const closeDate = moment(value).format('YYYY-MM-DD')
        const maximumApprovalDate = moment(approval).format('YYYY-MM-DD')

        return moment(closeDate).isBetween(openDate, maximumApprovalDate)
      },
      message: 'The close date must be between open and maximum approval date',
    })

    // Maximum approval date validation
    extend('approval_date_validation', {
      params: ['open', 'close'],
      validate(value, { open, close }) {
        const openDate = moment(open).format('YYYY-MM-DD')
        const closeDate = moment(close).format('YYYY-MM-DD')
        const maximumApprovalDate = moment(value).format('YYYY-MM-DD')

        return moment(maximumApprovalDate).isAfter(openDate) && moment(maximumApprovalDate).isAfter(closeDate)
      },
      message: 'The maximum approval date must be greater than the open and close date',
    })
  },
  async mounted() {
    // Empty the option
    this.servolutionOptionListsOptions = []

    // Set data
    const userData = JSON.parse(CryptoJS.AES.decrypt(sessionStorage.getItem('userData'), process.env.VUE_APP_COOKIE_SECRET).toString(CryptoJS.enc.Utf8))
    // const ministries = userData.map(elem => (`${elem.departments}`)).join(',')
    const churchIds = userData[0].churches.map(elem => elem).join(',')

    // Church (signed)
    const signChurches = await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/payload/sign`, {
      action: 'getChurchesByIds',
      payload: { churchIds },
    })
    this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/churches/${churchIds}`, {
      headers: { 'X-Payload-Token': signChurches.data.token },
    })
      .then(result => {
        this.isLoading = false
        _.forEach(result.data, church => {
            this.churchOptions.push({ id: church.couchdbId, name: church.name, status: church.status })
        })
      })

    // Servolution type (with payload token)
    import('@/utils/payloadToken').then(({ getPayloadToken }) => getPayloadToken(this.$http, 'listServolutionTypes', {})).then(token => this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/types`, {
        headers: { 'X-Payload-Token': token },
      })).then(result => {
      this.isLoading = false
      _.forEach(result.data, type => {
        this.servolutionTypeOptions.push({ id: type.id, name: type.name })
      })
    })
  },
  methods: {
    async formSubmitted() {
      // Check for cookies before submit
      // Get logged in status
      const isLoggedIn = isUserLoggedIn()
      // If not logged in, then redirect to login page
      if (!isLoggedIn) {
        return this.$router.replace('/login')
      }

      // Show loading
      this.isLoading = true

      // Check for servolution type
      let firstOptions = []
      let secondOptions = []
      if (this.servolutionType.id === 1) {
        firstOptions = this.firstOptionLists.map(o => o.id)
        secondOptions = this.secondOptionLists.map(o => o.id)
      } else {
        firstOptions = this.servolutionOptionLists.map(o => o.id)
      }

      // Set the events data
      const eventsData = {
        churchId: this.churches.id,
        churchName: this.churches.name,
        openDate: moment(this.open_date).format('YYYY-MM-DD'),
        closeDate: moment(this.close_date).format('YYYY-MM-DD'),
        maximumApprovalDate: moment(this.maximum_approval_date).format('YYYY-MM-DD'),
        baptismRequirement: this.baptism_required === 'yes',
        msjRequirement: this.msjSelected.id,
        nijRequirement: this.nij_required === 'yes',
        isAssessmentBroadcasted: this.isAssessmentBroadcasted === 'yes',
        servolutionTypeId: this.servolutionType.id,
        firstOptionMinistries: `{ ${firstOptions.map(elem => (`${elem}`)).join(',')} }`,
        secondOptionMinistries: `{ ${secondOptions.map(elem => (`${elem}`)).join(',')} }`,
        firstOptionSecondOptionType: this.firstSecondMinistryType && this.servolutionType.id === 1 ? this.firstSecondMinistryType.id : -1,
        termsAndConditions: this.termsConditions,
      }
      
      // Check if user has access
      if (!this.$can('add', 'servolution_event')) {
        return this.$router.replace({ name: 'misc-not-authorized' })
      }

      // Check for overlapping events with the previous one
      let isOverlapped = false
      const { getPayloadToken } = await import('@/utils/payloadToken')
      const churchEventsToken = await getPayloadToken(this.$http, 'getServolutionEventsByChurchId', { churchId: this.churches.id })
      this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/events/church/${this.churches.id}`, {
        headers: { 'X-Payload-Token': churchEventsToken },
      }).then(async events => {
          if (!_.isEmpty(events.data)) {
            // loop
            _.every(events.data, event => {
              if ((moment(moment(eventsData.openDate).format('YYYY-MM-DD')).isSameOrAfter(moment(event.openDate).format('YYYY-MM-DD')) && moment(moment(eventsData.openDate).format('YYYY-MM-DD')).isSameOrBefore(moment(event.closeDate).format('YYYY-MM-DD'))) || (moment(moment(event.openDate).format('YYYY-MM-DD')).isSameOrAfter(moment(eventsData.openDate).format('YYYY-MM-DD')) && moment(moment(event.openDate).format('YYYY-MM-DD')).isSameOrBefore(moment(eventsData.closeDate).format('YYYY-MM-DD')))) {
                // Response
                isOverlapped = true
                return false
              }

              return true
            })

            // Check if there's an overlapping date
            if (isOverlapped) {
              this.isLoading = false
              return this.$router.replace({ name: 'servolution-events' })
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: 'Event date is overlapping with the previous event creation.',
                    },
                  })
                })
            }
          }

          if (isOverlapped) return

          // Save event (with payload token)
          const createEventToken = await getPayloadToken(this.$http, 'createServolutionEvent', eventsData)
          await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/events`, eventsData, {
            headers: { 'X-Payload-Token': createEventToken },
          })
          const churchMinistryListToken = await getPayloadToken(this.$http, 'getServolutionChurchMinistriesByChurchId', { churchId: this.churches.id })
          const existingChurchMinistries = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${this.churches.id}`, {
            headers: { 'X-Payload-Token': churchMinistryListToken },
          })

          await Promise.all(this.auditions.map(async audition => {
            const auditionData = {
              churchId: this.churches.id,
              divisionsId: audition.id,
              ministryTypeId: 1,
              updatedAt: new Date(),
            }
            if (!_.isEmpty(existingChurchMinistries.data)) {
              const churchMinistry = _.find(existingChurchMinistries.data, { churchId: this.churches.id, divisionsId: auditionData.divisionsId })
              if (!(_.isNull(churchMinistry) || _.isUndefined(churchMinistry))) {
                const patchToken = await getPayloadToken(this.$http, 'updateServolutionChurchMinistry', auditionData, churchMinistry.id)
                await this.$http.patch(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${churchMinistry.id}`, auditionData, { headers: { 'X-Payload-Token': patchToken } })
              } else {
                const createToken = await getPayloadToken(this.$http, 'createServolutionChurchMinistry', auditionData)
                await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, auditionData, { headers: { 'X-Payload-Token': createToken } })
              }
            } else {
              const createToken = await getPayloadToken(this.$http, 'createServolutionChurchMinistry', auditionData)
              await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, auditionData, { headers: { 'X-Payload-Token': createToken } })
            }
          }))
          await Promise.all(this.interviews.map(async interview => {
            const interviewData = {
              churchId: this.churches.id,
              divisionsId: interview.id,
              ministryTypeId: 2,
              updatedAt: new Date(),
            }
            if (!_.isEmpty(existingChurchMinistries.data)) {
              const churchMinistry = _.find(existingChurchMinistries.data, { churchId: this.churches.id, divisionsId: interviewData.divisionsId })
              if (!(_.isNull(churchMinistry) || _.isUndefined(churchMinistry))) {
                const patchToken = await getPayloadToken(this.$http, 'updateServolutionChurchMinistry', interviewData, churchMinistry.id)
                await this.$http.patch(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${churchMinistry.id}`, interviewData, { headers: { 'X-Payload-Token': patchToken } })
              } else {
                const createToken = await getPayloadToken(this.$http, 'createServolutionChurchMinistry', interviewData)
                await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, interviewData, { headers: { 'X-Payload-Token': createToken } })
              }
            } else {
              const createToken = await getPayloadToken(this.$http, 'createServolutionChurchMinistry', interviewData)
              await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, interviewData, { headers: { 'X-Payload-Token': createToken } })
            }
          }))

          this.isLoading = false
          return this.$router.replace({ name: 'servolution-events' }).then(() => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Data has been saved successfully.',
              },
            })
          })
        }).catch(() => {
          this.isLoading = false
        })
    },
    validationFormSchedule() {
      // Loading
      this.isLoading = true

      // Reinitiate
      this.auditions = []
      this.interviews = []
      this.firstOptionLists = []
      this.secondOptionLists = []

      return new Promise((resolve, reject) => {
        import('@/utils/payloadToken').then(({ getPayloadToken }) => getPayloadToken(this.$http, 'getServolutionChurchMinistriesByChurchId', { churchId: this.churches.id })).then(token => this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${this.churches.id}`, {
            headers: { 'X-Payload-Token': token },
          })).then(result => {
            // If data is not empty
            if (!_.isEmpty(result.data)) {
              // Stop loading
              this.isLoading = false

              result.data = _.sortBy(result.data, o => o.divisions.ministries.name)
              _.forEach(result.data, list => {
                if (list.ministryTypeId === 1) {
                  this.auditions.push(
                    {
                      id: list.divisionsId,
                      ministry: list.divisions.ministries.name,
                      division: list.divisions.name,
                      type: list.ministryTypeId,
                    },
                  )
                } else {
                  this.interviews.push(
                    {
                      id: list.divisionsId,
                      ministry: list.divisions.ministries.name,
                      division: list.divisions.name,
                      type: list.ministryTypeId,
                    },
                  )
                }
              })
            } else {
              // Get from default (with payload token)
              import('@/utils/payloadToken').then(({ getPayloadToken }) => getPayloadToken(this.$http, 'listDivisions', {})).then(divToken => this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/divisions?filter={"include":[{"relation":"ministries","scope":{"order":["name asc"]}},{"relation": "ministryType"}]}`, {
                  headers: { 'X-Payload-Token': divToken },
                })).then(lists => {
                  // Stop loading
                  this.isLoading = false

                  lists.data = _.sortBy(lists.data, o => o.ministries.name)
                  _.forEach(lists.data, list => {
                    if (list.ministryTypeId === 1) {
                      this.auditions.push(
                        {
                          id: list.id,
                          ministry: list.ministries.name,
                          division: list.name,
                          type: list.ministryTypeId,
                        },
                      )
                    } else {
                      this.interviews.push(
                        {
                          id: list.id,
                          ministry: list.ministries.name,
                          division: list.name,
                          type: list.ministryTypeId,
                        },
                      )
                    }
                  })
                })
            }
          })

        this.$refs.schedule.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormRequirements() {
      return new Promise((resolve, reject) => {
        // Check for terms & conditions content
        if (this.termsConditionsLength === 1) {
          this.$swal({
            title: 'Error',
            text: ' Please insert the terms & conditions content',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
          reject()
        }

        this.$refs.requirements.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormMinistryTypes() {
      // Empty the option
      this.servolutionOptionListsOptions = []
      this.firstOptionListsOptions = []
      this.secondOptionListsOptions = []
      
      return new Promise((resolve, reject) => {
        // Concat from auditions and interviews lists
        this.rows = _.sortBy(_.concat(this.auditions, this.interviews), o => o.ministry)

        // If first and second option
        if (this.servolutionType.id === 1) {
          // First option
          _.forEach(this.rows, row => {
            this.firstOptionListsOptions.push({ id: row.id, name: `${row.ministry} - ${row.division}` })
          })

          // Second option
          _.forEach(this.interviews, interview => {
            this.secondOptionListsOptions.push({ id: interview.id, name: `${interview.ministry} - ${interview.division}` })
          })
        } else {
          // All rows
          _.forEach(this.rows, row => {
            this.servolutionOptionListsOptions.push({ id: row.id, name: `${row.ministry} - ${row.division}` })
          })
        }

        // If first and second option
        // if (this.servolutionType.id === 1) {
        //   // Audition
        //   _.forEach(this.auditions, audition => {
        //     this.firstOptionListsOptions.push({ id: audition.id, name: `${audition.ministry} - ${audition.division}` })
        //   })

        //   // Interview
        //   _.forEach(this.interviews, interview => {
        //     this.secondOptionListsOptions.push({ id: interview.id, name: `${interview.ministry} - ${interview.division}` })
        //   })
        // } else {
        //   // All rows
        //   // Concat from auditions and interviews lists
        //   this.rows = _.sortBy(_.concat(this.auditions, this.interviews), o => o.ministry)
        //   _.forEach(this.rows, row => {
        //     this.servolutionOptionListsOptions.push({ id: row.id, name: `${row.ministry} - ${row.division}` })
        //   })
        // }

        // Validate
        this.$refs.ministryTypes.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormMinistryOptions() {
      return new Promise((resolve, reject) => {
        this.$refs.ministryOptions.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    onEditorReady(quill) {
      this.termsConditionsLength = quill.getLength()
    },
    onEditorChange({ quill }) {
      this.termsConditionsLength = quill.getLength()
    },
    firstOptionSelected() {
      const currentSelected = _.find(this.firstOptionLists, { id: this.firstOptionLists[this.firstOptionLists.length - 1].id })
      const isExistsInSecondOptions = _.find(this.secondOptionLists, { id: currentSelected.id })

      if (isExistsInSecondOptions) {
        const index = _.findIndex(this.secondOptionLists, { id: currentSelected.id })
        this.secondOptionLists.splice(index, 1)
      }
    },
    secondOptionSelected() {
      const currentSelected = _.find(this.secondOptionLists, { id: this.secondOptionLists[this.secondOptionLists.length - 1].id })
      const isExistsInFirstOptions = _.find(this.firstOptionLists, { id: currentSelected.id })

      if (isExistsInFirstOptions) {
        const index = _.findIndex(this.firstOptionLists, { id: currentSelected.id })
        this.firstOptionLists.splice(index, 1)
      }
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
</style>